import { render, staticRenderFns } from "./snapshot-edit.vue?vue&type=template&id=4b1b404e&scoped=true&"
import script from "./snapshot-edit.vue?vue&type=script&lang=js&"
export * from "./snapshot-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1b404e",
  null
  
)

export default component.exports